import AlertCircleFilled from "../../../../../../../../assets/AlertCircleFilled";
import CloseIcon from "../../../../../../../../assets/CloseIcon";
import Button from "../../../../../../../../common/Buttons/Button";
import Typography from "../../../../../../../../common/Typography";

const PaymentFailed = ({ state, setState }) => {
  const handleRetry = () => {
    setState({
      otp: "",
      phoneNumber: "",
      step: "enter-phone",
      paymentFailedReason: "",
    });
  };

  return (
    <div className="payment-failed-content">
      <div className="error-icon">
        <div className="white-bg">
          <CloseIcon
            width="16"
            height="16"
            color="#DC3636"
            handleClick={() => {}}
          />
        </div>
      </div>
      <Typography tag="h1" size="display-xl" weight="medium">
        Uh-oh, You’re payment didn’t go through!
      </Typography>
      <div className="failed-reason-card">
        <div className="failed-reason-card-head">
          <AlertCircleFilled size={24} color="#DC3636" />
          <Typography weight="medium">REASON OF FAILURE</Typography>
        </div>
        <Typography customClass="failed-reason" weight="medium">
          {state.paymentFailedReason || "--"}
        </Typography>
      </div>
      <Button
        fullWidth={true}
        text="Retry Payment"
        customClass="action-btn"
        handleClick={handleRetry}
      />
    </div>
  );
};
export default PaymentFailed;
